import React, { useEffect, useMemo, useState } from "react";
import { useTable, useRowSelect, useExpanded } from "react-table";

const PastPaymentsInvoiceDetails = ({ columns, data, sublevelInvoiceLoading }) => {
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({
      columns,
      data,
    });

  return !sublevelInvoiceLoading ? (
    <table className="ml-20" {...getTableProps()}>
      <thead>
        {" "}
        {headerGroups.map((headerGroup) => (
          <tr {...headerGroup.getHeaderGroupProps()}>
            {" "}
            {headerGroup.headers.map((column) => (
              <th
                className="pb-[16px] pt-[24px] text-left font-[600] text-[14px] pl-2"
                {...column.getHeaderProps()}
                style={{ width: column.width }}
              >
                {" "}
                {column.render("Header")}{" "}
              </th>
            ))}{" "}
          </tr>
        ))}{" "}
      </thead>{" "}
      <tbody {...getTableBodyProps()}>
        {" "}
        {rows.map((row) => {
          prepareRow(row);
          return (
            <tr className="!h-fit" {...row.getRowProps()}>
              {" "}
              {row.cells.map((cell) => {
                return (
                  <td
                    {...cell.getCellProps()}
                    className="p-2"
                    style={{ width: cell.column.width }}
                  >
                    {" "}
                    {cell.render("Cell")}{" "}
                  </td>
                );
              })}{" "}
            </tr>
          );
        })}{" "}
      </tbody>{" "}
    </table>
  ) : (
<div className="flex justify-center items-center">
  <div className="w-5 h-5 border-2 border-gray-300 border-t-gray-600 rounded-full animate-spin"></div>
</div>
  );
};

export default PastPaymentsInvoiceDetails;
